import { useFeatureAvailable, Feature } from 'App/components/hooks/featureHelper';

export default function useAdvancedSearchAllowed() {
	return useFeatureAvailable(Feature.ADVANCED_SEARCH);
}
